import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  padding: 40px 0 70px;
  h2 {
    font: italic bold 36px 'Times new roman';
    margin: 0 0 20px;
    text-align: center;
  }
  img {
    margin: 30px auto;
    display: block;
    max-width: 100%;
  }
  a {
    margin: 0 auto;
    cursor: pointer;
    max-width: 480px;
    width: 100%;
    background: #F1A857;
    display: flex;
    border-radius: 3px;
    border: 0;
    color: #fff;
    height: 60px;
    align-items: center;
    font-size: 16px;
    padding: 0;
    text-decoration: none;
    .text {
      height: 100%;
      flex-grow: 1;
      border-right: 1px solid #D99440;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .icon {
      display: flex;
      align-items: center;
      min-width: 82px;
      justify-content: center;
      i {
        width: 24px;
        background: url(/images/streamline-icon-image-file-download@140x140@2x.png) center no-repeat;
        height: 24px;
        background-size: contain;
      }
    }
  }
`

class BlockImage extends Component {
  render () {
    const { children } = this.props;
    return (
      <Container>
        <div className="wrapper">
          { children }
        </div>
      </Container>
    )
  }
}

BlockImage.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
};

export default BlockImage;
